<template>
  <div class="chart-container w-full overflow-x-auto">
    <h2 class="text-center text-xl font-semibold mb-2 uppercase">Resumo anual</h2>
    <Line
      class="w-full"
      id="yearly-revenue-chart"
      ref="chart"
      :data="chartData"
      :options="chartOptions"
      :height="450"
    />
  </div>
</template>

<script>
import { defineComponent, watch, nextTick } from 'vue'
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, LineController, CategoryScale, LinearScale, PointElement, LineElement)

export default defineComponent({
  name: 'YearlyRevenueChart',
  components: { Line },
  props: {
    labels: {
      type: Array,
      required: true
    },
    dataset: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      chartData: {
        labels: this.labels,
        datasets: [
          {
            label: this.dataset.label,
            data: this.dataset.data,
            borderColor: this.dataset.borderColor,
            backgroundColor: this.dataset.backgroundColor,
            tension: 0.3,
            borderWidth: 2,
            pointRadius: 4
          }
        ]
      },
      chartOptions: {
        responsive: false,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            callbacks: {
              label (context) {
                const rawValue = context.raw
                const numeric = Number(rawValue) || 0
                return 'R$ ' + numeric.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })
              }
            }
          },
          legend: {
            display: true,
            position: 'top'
          }
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Mês'
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            }
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'total arrecadado'
            },
            ticks: {
              callback (value) {
                return 'R$ ' + Number(value).toLocaleString('pt-BR', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })
              }
            }
          }
        }
      }
    }
  },
  watch: {
    labels (newLabels) {
      this.chartData.labels = newLabels
      this.updateChart()
    },
    dataset: {
      handler (newDataset) {
        this.chartData.datasets = [
          {
            label: newDataset.label,
            data: newDataset.data,
            borderColor: newDataset.borderColor,
            backgroundColor: newDataset.backgroundColor,
            tension: 0.3,
            borderWidth: 2,
            pointRadius: 4
          }
        ]
        this.updateChart()
      },
      deep: true
    }
  },
  methods: {
    updateChart () {
      nextTick(() => {
        const chart = this.$refs.chart
        if (chart && chart.chart) {
          chart.chart.update()
        }
      })
    }
  }
})
</script>

<style scoped>
.chart {
  margin: 1rem auto 1rem;
  overflow: hidden;
}
</style>
